<template>
  <div class="fill-height">
    <template v-if="isArchivingEnabled">
      <template v-if="!configPending">
        <transition name="app-fade">
          <div :key="$route.fullPath">
            <router-view v-slot="{ Component }">
              <component :is="Component" />
            </router-view>
          </div>
        </transition>
        <ArchivesSidebar />
      </template>
      <div v-else class="d-flex align-center justify-center h-100">
        <v-progress-circular
          style="width: 64px; height: 64px"
          indeterminate
          color="primary"
          size="64"
        />
      </div>
    </template>
    <template v-else>
      <ArchivesPaywallDialog/>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { useArchivesStore } from '@/stores/archivesStore'

import ArchivesSidebar from '../ArchivesSidebar.vue'
import ArchivesPaywallDialog from '../views/ArchivesPaywallDialog.vue'

export default {
  name: 'ArchivesLayout',
  components: {
    ArchivesSidebar,
    ArchivesPaywallDialog,
  },
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  computed: {
    configPending() {
      return this.archivesStore.configPending
    },
    ...mapGetters('user', ['isArchivingEnabled']),
  },
  created () {
    if (this.isArchivingEnabled) {
      // This is always used, so we fetch it here
      this.archivesStore.getArchiveConfig()
    }
  },
}
</script>
